import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <section className="relative pt-20 md:pt-24 pb-14 md:pb-20 px-4 md:px-6">
          <div className="absolute inset-0 top-0 h-80 md:h-96 overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20warm%20gradient%20background%20with%20soft%20flowing%20geometric%20shapes%2C%20orange%20and%20amber%20tones%2C%20corporate%20modern%20atmosphere%2C%20clean%20minimalist%20aesthetic%2C%20professional%20technology%20company%2C%20bright%20warm%20highlights%20on%20dark%20background&width=1920&height=600&seq=about-hero-bg&orientation=landscape"
              alt=""
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-background-950/40 to-background-50"></div>
          </div>

          <div className="relative z-10 max-w-7xl mx-auto">
            <nav className="flex items-center gap-2 text-sm mb-6" aria-label="面包屑导航">
              <Link to="/" className="text-background-50/80 hover:text-background-50 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs text-background-50/60"></i>
              <span className="text-background-50 font-medium">关于我们</span>
            </nav>

            <div className="max-w-3xl">
              <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-background-50 mb-4">
                关于<strong className="text-primary-400">快猫视频</strong>
              </h1>
              <p className="text-sm md:text-base text-background-50/80 leading-relaxed max-w-xl">
                快猫视频是一款风靡全网的短视频娱乐平台，致力于为用户提供最优质的短视频内容体验。
              </p>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14 items-center">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
                  品牌<strong className="text-primary-500">故事</strong>
                </h2>
                <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                  <p>
                    快猫视频成立于2020年，由一群热爱短视频文化的年轻创业者共同创立。团队秉持"让快乐更简单"的初心，致力于打造一个内容丰富、体验流畅、氛围健康的短视频娱乐平台。
                  </p>
                  <p>
                    经过数年的快速发展，快猫视频已经从一个小型创业项目成长为拥有数千万用户的短视频平台。截至2026年，快猫视频累计注册用户突破5000万，月活跃用户超过3000万，每日视频更新量达到10万条以上。
                  </p>
                  <p>
                    快猫视频始终坚持以用户为中心，通过不断创新的AI推荐技术和严格的内容审核机制，为用户打造一个既能发现乐趣、又能安心使用的短视频社区。我们相信，好的内容能够连接每一个人，让世界变得更加有趣和温暖。
                  </p>
                </div>
              </div>
              <div className="relative h-72 md:h-96 rounded-2xl overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20team%20collaboration%2C%20diverse%20young%20professionals%20working%20together%2C%20warm%20natural%20lighting%2C%20open%20workspace%2C%20glass%20walls%2C%20plants%2C%20innovative%20atmosphere%2C%20positive%20energy%2C%20corporate%20culture%20photography&width=800&height=600&seq=about-brand&orientation=squarish"
                  alt="快猫视频团队"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-12 md:mb-14">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                平台<strong className="text-primary-500">荣誉</strong>
              </h2>
              <p className="text-sm text-foreground-500 max-w-lg mx-auto">
                快猫视频获得的行业认可与用户口碑
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className="ri-trophy-line text-2xl"></i>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-950 mb-2">最佳用户体验奖</h3>
                <p className="text-sm text-foreground-500">2025年度中国移动互联网大奖</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                  <i className="ri-star-line text-2xl"></i>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-950 mb-2">App Store 年度推荐</h3>
                <p className="text-sm text-foreground-500">连续三年入选App Store精品推荐</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mb-4">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-950 mb-2">绿色安全认证</h3>
                <p className="text-sm text-foreground-500">国家信息安全等级保护三级认证</p>
              </div>
              <div className="p-6 rounded-2xl bg-background-50 border border-background-200/70 text-center">
                <div className="w-14 h-14 mx-auto flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                  <i className="ri-user-heart-line text-2xl"></i>
                </div>
                <h3 className="text-base font-semibold font-heading text-foreground-950 mb-2">用户满意度第一</h3>
                <p className="text-sm text-foreground-500">2026年短视频平台用户满意度调查</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
          <div className="max-w-7xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 md:gap-14">
              <div>
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-5">
                  联系<strong className="text-primary-500">我们</strong>
                </h2>
                <p className="text-sm text-foreground-500 mb-8">
                  如果你有任何问题或建议，欢迎通过以下方式联系我们。我们的客服团队将在24小时内回复你的消息。
                </p>

                <div className="space-y-5">
                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-950 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-500">contact@kuaimaovideo.com</p>
                      <p className="text-sm text-foreground-500">support@kuaimaovideo.com</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-phone-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-950 mb-1">客服电话</h4>
                      <p className="text-sm text-foreground-500">400-888-6666</p>
                      <p className="text-sm text-foreground-500">工作时间：周一至周日 9:00-21:00</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-950 mb-1">公司地址</h4>
                      <p className="text-sm text-foreground-500">北京市朝阳区科技园路188号</p>
                      <p className="text-sm text-foreground-500">创新大厦A座15层 邮编：100020</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-wechat-line text-lg"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-semibold text-foreground-950 mb-1">官方微信</h4>
                      <p className="text-sm text-foreground-500">搜索关注"快猫视频"公众号</p>
                      <p className="text-sm text-foreground-500">获取最新活动与福利资讯</p>
                    </div>
                  </div>
                </div>
              </div>

              <div>
                <div className="rounded-2xl bg-background-100 border border-background-200/70 p-6">
                  <h3 className="text-base font-semibold font-heading text-foreground-950 mb-4">公司信息</h3>
                  <dl className="space-y-4 text-sm">
                    <div className="flex justify-between py-2 border-b border-background-200/50">
                      <dt className="text-foreground-500">公司全称</dt>
                      <dd className="text-foreground-950 font-medium">北京快猫科技有限公司</dd>
                    </div>
                    <div className="flex justify-between py-2 border-b border-background-200/50">
                      <dt className="text-foreground-500">成立时间</dt>
                      <dd className="text-foreground-950 font-medium">2020年3月</dd>
                    </div>
                    <div className="flex justify-between py-2 border-b border-background-200/50">
                      <dt className="text-foreground-500">注册资本</dt>
                      <dd className="text-foreground-950 font-medium">5000万元人民币</dd>
                    </div>
                    <div className="flex justify-between py-2 border-b border-background-200/50">
                      <dt className="text-foreground-500">员工规模</dt>
                      <dd className="text-foreground-950 font-medium">500+人</dd>
                    </div>
                    <div className="flex justify-between py-2 border-b border-background-200/50">
                      <dt className="text-foreground-500">服务用户</dt>
                      <dd className="text-foreground-950 font-medium">5000万+</dd>
                    </div>
                    <div className="flex justify-between py-2">
                      <dt className="text-foreground-500">平台定位</dt>
                      <dd className="text-foreground-950 font-medium">短视频娱乐平台</dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于快猫视频',
            description: '快猫视频是一款风靡全网的短视频娱乐平台。了解快猫视频的品牌故事、平台荣誉和联系方式。',
            url: 'https://www.kuaimaovideo.com/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '快猫视频',
              url: 'https://www.kuaimaovideo.com',
            },
            breadcrumb: {
              '@type': 'BreadcrumbList',
              itemListElement: [
                { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.kuaimaovideo.com/' },
                { '@type': 'ListItem', position: 2, name: '关于我们' },
              ],
            },
            about: {
              '@type': 'Organization',
              name: '快猫视频',
              legalName: '北京快猫科技有限公司',
              url: 'https://www.kuaimaovideo.com',
              email: 'contact@kuaimaovideo.com',
              telephone: '400-888-6666',
              address: {
                '@type': 'PostalAddress',
                streetAddress: '科技园路188号创新大厦A座15层',
                addressLocality: '北京',
                addressRegion: '朝阳区',
                postalCode: '100020',
                addressCountry: 'CN',
              },
            },
          }),
        }}
      />
    </>
  );
}